
function sendData(url, method, onSuccess, onError, data) {
    const xhr = new XMLHttpRequest();
    xhr.responseType = "json";

    xhr.addEventListener("load", () => {
      if (xhr.status === 200) {
        console.log(xhr.response);
        if (xhr.response.status) {
          onSuccess(xhr.response);
        } else {
          //вывести ошибки
        }

        
      } else {
        onError(noConnection);
      }
    });

    xhr.addEventListener("error", () => {
      console.log(xhr.response);
      onError(noConnection);
    });
    xhr.addEventListener("timeout", () => {
      onError(noConnection);
    });

    xhr.timeout = 5000;

    xhr.open(method, url, true);
    // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    // xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send(data);
}


export default sendData;